import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "首页", path: "/" },
  { label: "香氛系列", path: "/category/fragrance" },
  { label: "肌肤养护", path: "/category/skincare" },
  { label: "香氛文章", path: "/category/articles" },
  { label: "关于我们", path: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/60"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span
              className={`font-heading text-xl md:text-2xl font-semibold transition-colors duration-300 ${
                scrolled ? "text-primary-600" : "text-background-50"
              }`}
            >
              媚肉之香
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  isActive(link.path)
                    ? scrolled
                      ? "bg-primary-100 text-primary-700"
                      : "bg-white/20 text-background-50"
                    : scrolled
                      ? "text-foreground-600 hover:text-primary-600 hover:bg-primary-50"
                      : "text-background-50/80 hover:text-background-50 hover:bg-white/10"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer rounded-full transition-colors ${
              scrolled ? "text-foreground-800" : "text-background-50"
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-6 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isActive(link.path)
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-600 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}